/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
@keyframes ux-horizontal-loader-loading {
  0%, 100% {
    transform: translateX(var(--ux-loader-animation-offset-start));
  }
  50% {
    transform: translateX(var(--ux-loader-animation-offset-end));
  }
}
@keyframes ux-spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
:host {
  display: inline-block;
}

:host([variant=horizontal]) {
  background: var(--ux-loader-track-color);
  border-radius: var(--ux-loader-bar-radius);
  height: var(--ux-loader-bar-size);
  overflow: hidden;
  position: relative;
  width: 100%;
}
:host([variant=horizontal])::before {
  content: "";
  animation: ux-horizontal-loader-loading var(--ux-loader-animation-duration, 2s) infinite ease;
  background: var(--ux-loader-bar-color);
  border-radius: var(--ux-loader-bar-radius);
  height: var(--ux-loader-bar-size);
  left: 50%;
  position: absolute;
  transform: translateX(-150%);
  width: 50%;
}

:host([variant=spinner]) {
  border: 6px solid #eff0f4;
  border-radius: 50%;
  height: 50px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  vertical-align: middle;
  width: 50px;
}
:host([variant=spinner])::after {
  animation: ux-spin 1s linear infinite;
  border: 6px solid transparent;
  border-radius: 50%;
  border-top-color: var(--ux-spinner-track-color);
  content: "";
  inset: -6px;
  position: absolute;
}

@media (prefers-reduced-motion) {
  :host([variant=horizontal])::before {
    animation-duration: 4s;
  }
  :host([variant=spinner])::after {
    animation-duration: 3s;
  }
}